<style lang="scss">
.vel-img-title {
  background-color: black;
  padding: 6px 9px;
  color: #fff !important;
  font-size: 14px !important;
}
</style>

<template>
  <v-row>
    <vue-easy-lightbox
      :visible="lightboxVisible"
      :imgs="lightboxImages"
      :index="lightboxIndex"
      @hide="lightboxVisible = false"
    ></vue-easy-lightbox>

    <v-col cols="12" v-if="title">
      <h2 class="text-h5 font-weight-regular text-uppercase black--text">
        {{ title }}
      </h2>
    </v-col>

    <v-col
      v-for="(item, i) in loadedItems"
      :key="item.id"
      class="d-flex child-flex"
      cols="6"
      sm="4"
      xl="2"
    >
      <v-img
        style="cursor: pointer"
        @click="showLightboxImage(i)"
        :src="item.thumbnail"
        :aspect-ratio="500 / 334"
        class="grey lighten-2"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </v-col>
    <v-col cols="12" v-if="!allLoaded && persistentLoadMoreBtn">
      <div class="text-center">
        <div class="pb-5" :title="allLoaded ? 'Rohkem referentse ei ole' : 'Lae rohkem referentse'">
          <v-btn
            color="black"
            :dark="!allLoaded"
            :loading="loading"
            @click="loadMore"
            :disabled="allLoaded"
          >
            Lae rohkem
          </v-btn>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";
export default {
  components: {
    VueEasyLightbox,
  },
  mounted() {
    this.setLightboxItems();
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
    persistentLoadMoreBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sliceTo: 12,
      loading: null,
      lightboxVisible: false,
      lightboxImages: null,
      lightboxIndex: null,
    };
  },
  computed: {
    loadedItems() {
      return this.items.slice(0, this.sliceTo);
    },
    allLoaded() {
      return this.items.length >= this.loadedItems.length;
    },
  },
  methods: {
    loadMore() {
      if (this.loading) return;
      this.loading = true;

      setTimeout(() => {
        this.sliceTo += 12;
        this.loading = false;
      }, 500);
    },
    setLightboxItems() {
      this.lightboxImages = this.items.map((el, i) => {
        return {
          title: el.title ? el.title : "Foto " + (i + 1),
          src: el.original,
        };
      });
    },
    showLightboxImage(index) {
      this.lightboxIndex = index; // index of imgList
      this.lightboxVisible = true;
    },
  },
};
</script>
